var __jsx = React.createElement;
import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { connect } from 'react-redux';
import Modal from '@spa/shared/components/Modal';
import Button from '@spa/shared/components/Unisystem/Button';
import Copy from '@spa/shared/svg/copy';
import EmailShare from '@spa/shared/svg/email-share';
import Whatsapp from '@spa/shared/svg/whatsapp';
import Messenger from '@spa/shared/svg/messenger';
import FacebookShare from '@spa/shared/svg/facebook-share';
import Twitter from '@spa/shared/svg/twitter';
import { getPropertyRentBy } from '@spa/shared/utils/property';
import { findPhotoById, photoUrl } from '@spa/shared/utils/photos';
import { RENT_BY_TRANSLATIONS } from '@spa/shared/constants/translations';
import { translateFromLanguage } from '@spa/shared/utils/transformers';
import { Buttons, Header, Photo, Title, Subtitle, Info, ModalGlobalStyle } from './styles';
import { MediaContext } from '@spa/shared/contexts/media';
import StatusBanner from '@spa/shared/components/Unisystem/StatusBanner';
import Check from '@spa/shared/svg/check';
import { theme } from '@spa/shared/theme';
import { trackSharedOffer } from '@spa/offer/store/actions/tracking';
var BUTTONS = [{
  label: 'Copy URL',
  icon: Copy,
  action: function action(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url);
      return true;
    }
    return false;
  }
}, {
  label: 'Send by e-mail',
  icon: EmailShare,
  action: function action(_ref) {
    var url = _ref.url,
      text = _ref.text;
    return window.open("mailto:?subject=".concat(encodeURIComponent(text), "&body=").concat(encodeURIComponent("".concat(text, " - ").concat(url))));
  }
}, {
  label: 'Whatsapp',
  icon: Whatsapp,
  action: function action(_ref2) {
    var url = _ref2.url,
      text = _ref2.text;
    return window.open("https://wa.me/?text=".concat(encodeURIComponent("".concat(text, " ").concat(url))), 'mozillaWindow', 'popup');
  }
}, {
  label: 'Messenger',
  icon: Messenger,
  action: function action(_ref3) {
    var url = _ref3.url;
    return window.open("https://www.facebook.com/dialog/send?link=".concat(url, "&app_id=").concat(process.env.FACEBOOK_APP_ID), 'mozillaWindow', 'popup');
  }
}, {
  label: 'Facebook',
  icon: FacebookShare,
  action: function action(_ref4) {
    var url = _ref4.url;
    return window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(url), 'mozillaWindow', 'popup');
  }
}, {
  label: 'Twitter',
  icon: Twitter,
  action: function action(_ref5) {
    var url = _ref5.url,
      text = _ref5.text;
    return window.open("https://twitter.com/intent/tweet?url=".concat(url, "&text=").concat(encodeURIComponent(text)), 'mozillaWindow', 'popup');
  }
}];
var Share = function Share(_ref6) {
  var _ref6$onClose = _ref6.onClose,
    onClose = _ref6$onClose === void 0 ? function () {} : _ref6$onClose,
    titleTranslations = _ref6.titleTranslations,
    cityTranslations = _ref6.cityTranslations,
    countryTranslations = _ref6.countryTranslations,
    mainPhoto = _ref6.mainPhoto,
    rentBy = _ref6.rentBy,
    trackSharedOfferAction = _ref6.trackSharedOfferAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useRouter = useRouter(),
    _useRouter$query = _useRouter.query,
    city = _useRouter$query.city,
    offerId = _useRouter$query.offerId;
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  var _useState = useState(false),
    isLinkCopied = _useState[0],
    setIsLinkCopied = _useState[1];
  var titleTranslated = translateFromLanguage(titleTranslations, language);
  var cityTranslated = translateFromLanguage(cityTranslations, language);
  var countryTranslated = translateFromLanguage(countryTranslations, language);
  var offerUrl = "".concat(process.env.APP_URL, "accommodation/").concat(city, "/").concat(offerId);
  var TOAST_TIME = 3000;
  var handleButtonClick = function handleButtonClick(button, url) {
    if (button.label === 'Copy URL') {
      button.action(url);
      setIsLinkCopied(true);
      setTimeout(function () {
        return setIsLinkCopied(false);
      }, TOAST_TIME);
      trackSharedOfferAction(button.label);
      return;
    }
    trackSharedOfferAction(button.label);
    button.action({
      url: url,
      text: "".concat(titleTranslated, " ").concat(t('in'), " ").concat(cityTranslated, ", ").concat(countryTranslated)
    });
  };
  return __jsx(Modal, {
    onClose: onClose,
    title: t('Share this place'),
    maxWidth: is.mobile ? undefined : '640px',
    className: "social-share"
  }, __jsx(ModalGlobalStyle, null), __jsx(Header, null, __jsx(Photo, {
    src: photoUrl({
      hash: mainPhoto.hash
    }),
    alt: offerId
  }), __jsx(Info, null, __jsx(Title, null, titleTranslated), __jsx(Subtitle, null, "".concat(t(rentBy), " ").concat(t('in'), " ").concat(cityTranslated, ", ").concat(countryTranslated)))), __jsx(Buttons, null, BUTTONS.map(function (button) {
    return __jsx(Button, {
      isTertiary: true,
      key: button.label,
      onClick: function onClick() {
        return handleButtonClick(button, offerUrl);
      }
    }, __jsx("span", null, __jsx(button.icon, null), t(button.label)));
  })), isLinkCopied && __jsx(StatusBanner, {
    icon: __jsx(Check, {
      color: theme.colors.blueTeal
    }),
    color: "blue",
    message: t('Link copied.')
  }));
};
var mapStateToProps = function mapStateToProps(_ref7) {
  var _ref7$offer$offerAggr = _ref7.offer.offerAggregate,
    _ref7$offer$offerAggr2 = _ref7$offer$offerAggr.accommodation_offer,
    titleTranslations = _ref7$offer$offerAggr2.title,
    mainPhotoId = _ref7$offer$offerAggr2.main_photo.id,
    unit_type = _ref7$offer$offerAggr2.property.unit_type,
    _ref7$offer$offerAggr3 = _ref7$offer$offerAggr.property_aggregate.property,
    lifecycle = _ref7$offer$offerAggr3.lifecycle,
    typology = _ref7$offer$offerAggr3.typology,
    _ref7$offer$offerAggr4 = _ref7$offer$offerAggr.globalization_aggregate,
    cityTranslations = _ref7$offer$offerAggr4.city.metadata.name_translations,
    countryTranslations = _ref7$offer$offerAggr4.country.metadata.name_translations,
    photos = _ref7$offer$offerAggr.photos;
  return {
    titleTranslations: titleTranslations,
    cityTranslations: cityTranslations,
    countryTranslations: countryTranslations,
    mainPhoto: findPhotoById(mainPhotoId, photos),
    rentBy: RENT_BY_TRANSLATIONS[getPropertyRentBy({
      typology: typology,
      lifecycle: lifecycle,
      unit_type: unit_type
    })]
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackSharedOfferAction: function trackSharedOfferAction(method) {
      return dispatch(trackSharedOffer({
        method: method
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Share);